module.exports = __webpack_public_path__ + "img/envelope1.f60f59f1.jpg";